var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "75BCD378-B25E-46D7-88BC-E5A14C1D50E4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 47.9998 0 47.9998 47.9996 0 47.9996"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Weboldal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Synflex-Swagers",
    transform: "translate(-546.000000, -1011.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(546.000000, 1011.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4496,18.2538 C30.5386,18.2538 29.7996,17.5148 29.7996,16.6038 C29.7996,15.6928 30.5386,14.9548 31.4496,14.9548 C32.3606,14.9548 33.0996,15.6928 33.0996,16.6038 C33.0996,17.5148 32.3606,18.2538 31.4496,18.2538 M24.1156,30.9298 C20.2946,30.9298 17.1856,27.8208 17.1856,23.9998 C17.1856,20.1788 20.2946,17.0698 24.1156,17.0698 C27.9366,17.0698 31.0456,20.1788 31.0456,23.9998 C31.0456,27.8208 27.9366,30.9298 24.1156,30.9298 M29.6166,12.5778 L18.3826,12.5778 C15.1806,12.5778 12.5776,15.1808 12.5776,18.3828 L12.5776,29.6178 C12.5776,32.8188 15.1806,35.4228 18.3826,35.4228 L29.6166,35.4228 C32.8186,35.4228 35.4226,32.8188 35.4226,29.6178 L35.4226,18.3828 C35.4226,15.1808 32.8186,12.5778 29.6166,12.5778",
    id: "Fill-1",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1153,19.5609 C21.6673,19.5609 19.6763,21.5519 19.6763,23.9999 C19.6763,26.4479 21.6673,28.4389 24.1153,28.4389 C26.5633,28.4389 28.5543,26.4479 28.5543,23.9999 C28.5543,21.5519 26.5633,19.5609 24.1153,19.5609",
    id: "Fill-3",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0698,29.6176 C38.0698,34.2786 34.2778,38.0696 29.6168,38.0696 L18.3818,38.0696 C13.7218,38.0696 9.9298,34.2786 9.9298,29.6176 L9.9298,18.3826 C9.9298,13.7216 13.7218,9.9296 18.3818,9.9296 L29.6168,9.9296 C34.2778,9.9296 38.0698,13.7216 38.0698,18.3826 L38.0698,29.6176 Z M35.4438,0.0006 L12.5558,-0.0004 C5.6498,-0.0004 -0.0002,5.6506 -0.0002,12.5556 L-0.0002,35.4436 C-0.0002,42.3496 5.6498,47.9996 12.5558,47.9996 L35.4438,47.9996 C42.3498,47.9996 47.9998,42.3496 47.9998,35.4436 L47.9998,12.5556 C47.9998,5.6506 42.3498,0.0006 35.4438,0.0006 L35.4438,0.0006 Z",
    id: "Fill-5",
    fill: "#363636",
    mask: "url(#mask-2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.31aa3ceedeff5a2506bd365291901183.svg";
export { ForwardRef as ReactComponent };